import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'hi',
  months: ['जनवरी', 'फरवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर'],
  monthsShort: ['जन', 'फर', 'मार्च', 'अप्रै', 'मई', 'जून', 'जुला', 'अग', 'सितं', 'अक्टू', 'नवं', 'दिसं'],
  weekdays: ['रविवार', 'सोमवार', 'मंगलवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार'],
  weekdaysMin: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
  weekdaysShort: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरू', 'शुक्र', 'शनि'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s वर्ष पहले', other: '%s वर्ष पहले' },
    M: { one: '%s माह पहले', other: '%s माह पहले' },
    w: { one: '%s सप्ताह पहले', other: '%s सप्ताह पहले' },
    d: { one: '%s दिन पहले', other: '%s दिन पहले' },
    h: { one: '%s घं॰ पहले', other: '%s घं॰ पहले' },
    m: { one: '%s मि॰ पहले', other: '%s मि॰ पहले' },
    s: { one: '%s से॰ पहले', other: '%s से॰ पहले' },
  },
  future: {
    y: { one: '%s वर्ष में', other: '%s वर्ष में' },
    M: { one: '%s माह में', other: '%s माह में' },
    w: { one: '%s सप्ताह में', other: '%s सप्ताह में' },
    d: { one: '%s दिन में', other: '%s दिन में' },
    h: { one: '%s घं॰ में', other: '%s घं॰ में' },
    m: { one: '%s मि॰ में', other: '%s मि॰ में' },
    s: { one: '%s से॰ में', other: '%s से॰ में' },
  },
  abbr: {
    y: { one: '%sवर्ष', other: '%sवर्ष' },
    M: { one: '%sमहीना', other: '%sमहीने' },
    w: { one: '%sसप्ताह', other: '%sसप्ताह' },
    d: { one: '%sदिन', other: '%sदिन' },
    h: { one: '%sघं', other: '%sघं' },
    m: { one: '%sमिनट', other: '%sमिनट' },
    s: { one: '%sसेकंड', other: '%sसेकंड' },
  },
  justNow: 'बस अभी',
  yesterday: 'बीता कल',
  today: 'आज',
  tomorrow: 'कल',
  weekStart: 0,
};
const localeName: LocaleName = 'hi';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
